export const education = [
  {
    school: "Kebbi State Univeristy of Science and Technology Aliero",
    certificate: "Bachelor in Elect/Elect Engineering",
    duration: "November 2016 - May 2022",
  },
  {
    school: "St. James Anglican College",
    certificate: "S.S.C.E/ W.A.E.C",
    duration: "September 2009 - August 2016",
    postHeld: [
      "I was a Library Prefect",
      "Came Second state level in cowbell competition",
      "Came first regional level and second in National level in NAFDAC Consumer Safety Club",
    ],
  },
  {
    school: "High Standard Nursery And Primary School",
    certificate: "Primary School Cert.",
    duration: "September 2004 - August 2009 ",
  },
];
